<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Transaction Report - TBA</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard"> Dashboard </router-link> /

      <b>TBA</b> /

      <b>Finance</b>
    </div>
    <!-- End of breadcrumbs -->

    <p></p>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <!-- ICON BG -->
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i class="nav-icon fas fa-handshake" style="font-size: 50px"></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Completed Transaction</p>
              <p class="text-primary text-24 line-height-1 mb-2">
                <span>{{ this.transaction }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- ICON BG -->
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i
              class="nav-icon fas fa-money-bill-wave"
              style="font-size: 50px"
            ></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Completed Amount</p>
              <p class="text-primary text-24 line-height-1 mb-2">
                <span>${{ formatMoney(this.total_sale) }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input class="form-control" type="date" v-model="date_from" />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input class="form-control" type="date" v-model="date_to" />
              </div>
            </div>
            <br />
            <div class="row">
              <div class="text-left col-6">
                <json-excel
                  class="btn btn-rounded btn-primary mr-1"
                  style="width: 150px"
                  :fetch="CallBackData"
                  :fields="json_fields"
                  type="csv"
                  worksheet="My Worksheet"
                  name="Takaful Admin Dashboard.csv"
                >
                  Excel
                </json-excel>
                <button
                  class="btn btn-rounded btn-primary"
                  style="width: 150px"
                  @click="toPDF()"
                >
                  PDF
                </button>
              </div>
              <div class="text-right col-6">
                <button
                  @click="submit_query()"
                  class="btn btn-rounded btn-primary mr-1"
                  style="width: 150px"
                >
                  Submit
                </button>
                <button
                  type="button"
                  class="btn btn-rounded btn-primary"
                  style="width: 150px"
                  @click="onReset"
                >
                  Reset
                </button>
              </div>
            </div>

            <br />
            <div class="input-group mb-4 d-flex flex-row-reverse p2">
              <button
                type="button"
                class="btn btn-primary mr-1"
                @click="onSearch"
              >
                <i class="fas fa-search"></i>
              </button>
              <div class="form-outline mr-1">
                <input type="input" v-model="searchID" class="form-control" />
              </div>
            </div>
            <div class="table-responsive">
              <table
                id="transaction_table"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: left"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Order ID</th>
                    <th>Status</th>
                    <th>Payment Type</th>
                    <th>Customer IC No.</th>
                    <th>Payment For</th>
                    <th>Product</th>
                    <th>Date Purchase</th>
                    <th>Date Payment</th>
                    <!-- <th>Timezone</th> -->
                    <th>Amount</th>
                    <th>Discount Token Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="details.length == 0">
                    <td colspan="11" style="text-align: center">No Data</td>
                  </tr>
                  <tr v-for="(purchase, pindex) in details" :key="pindex">
                    <td>{{ pindex + 1 }}</td>
                    <td>{{ purchase.bpgs_id }}</td>
                    <td>{{ purchase.status_name }}</td>
                    <td>{{ purchase.payment_type }}</td>
                    <td>
                      <router-link :to="customerPage(purchase.ic_number)">
                        {{ purchase.ic_number }}
                      </router-link>
                    </td>
                    <td>
                      <span v-if="purchase.type == 1">Installment</span>
                      <span v-else-if="purchase.type == 2">New Purchase</span>
                      <span v-else-if="purchase.type == 3">Renewal</span>
                      <span v-else-if="purchase.type == 4">Endorsement</span>
                    </td>
                    <td>{{ purchase.product_name }}</td>
                    <td>
                      {{
                        purchase.created_at | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>
                      <span v-if="purchase.timezone_date == null">-</span>
                      <span v-else>
                      {{
                        purchase.timezone_date | moment("Do MMMM YYYY, h:mm:ss a")
                      }}
                      </span>
                    </td>
                    <!-- <td>
                      {{ purchase.timezone }}
                    </td> -->
                    <td>${{ formatMoney(purchase.price) }}</td>
                    <td>{{ purchase.discount_price ? "$" + formatMoney(purchase.discount_price) : '-'}}</td>
                  </tr>
                </tbody>
              </table>

              <pagination
                v-model="pageInfo.current_page"
                :per-page="pageInfo.per_page"
                :records="pageInfo.total"
                @paginate="handlePageChange"
              />
            </div>
          </div>
        </div>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
        <br />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { setTimeout } from "timers";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";
import { getAuthHeaders } from "@/services/UserTokenService";
import { getRequest, postRequest } from "@/services/RequestService";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export default {
  name: "report-transactions-tba",
  components: { Pagination, Loading, JsonExcel },

  data() {
    return {
      details: [],
      statusFilter: "",
      productFilter: "",
      date_from: "",
      date_to: "",
      transaction: "",
      total_sale: "",
      statuses: [],
      products: [],
      pageInfo: {
        current_page: 1,
        next_page_url: null,
        previous_page_url: null,
        total: 0,
        count: 0,
        per_page: 0,
        last_page: 0,
      },
      isLoading: false,
      searchID: "",
      json_fields: {
        ID: "id",
        "Order ID": "bpgs_id",
        Status: "status_name",
        "Payment Type": "payment_type",
        "Customer IC No.": "ic_number",
        "Payment For": "type_name",
        Product: "product_name",
        "Date Purchase": "created_at",
        "Date Payment": "timezone_date",
        Amount: "price",
        "Discount Amount": "discount_price",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      _api: null,
      _request: {},
    };
  },

  methods: {
    async toPDF() {
      let datas = await this.CallBackData();

      const new_datas = datas.map((element) => Object.values(element));

      let doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });

      autoTable(doc, {
        head: [
          [
            "No",
            "Order ID",
            "Status",
            "Payment Type",
            "Customer IC No.",
            "Payment For",
            "Product",
            "Date Purchase",
            "Date Payment",
            "Amount",
            "Discount Amount",
          ],
        ],
        body: new_datas,
      });
      doc.save("TBA Transaction Report.pdf");
    },

    //download excel
    async CallBackData() {
      this.isLoading = true;
      let tbType = this.$route.params.tbType;

      let api_url = `/reports/transactions/download?tbType=${tbType}`;

      this.json_data = [];

      let res = await postRequest(api_url, this._request);

      for (let i = 0; i < res.data.records.length; i++) {
        this.json_data.push({
          id: i + 1,
          bpgs_id: res.data.records[i].bpgs_id,
          status_name: res.data.records[i].status_name,
          payment_type: res.data.records[i].payment_type,
          ic_number: res.data.records[i].ic_number,
          type_name: res.data.records[i].type_name,
          product_name: res.data.records[i].product_name,
          created_at: res.data.records[i].created_at,
          timezone_date: res.data.records[i].timezone_date,
          price: res.data.records[i].price,
          discount_price: res.data.records[i].discount_price,
        });
      }

      const last_row = {
        id: "-",
        bpgs_id: "-",
        status_name: "Completed",
        payment_type: "-",
        ic_number: "-",
        type_name: "-",
        product_name: "-",
        created_at: "-",
        timezone_date: "-",
        price: this.total_sale,
        discount_price: "",
      };

      this.json_data = [...this.json_data, last_row];
      this.isLoading = false;

      return this.json_data;
    },

    async loadDetails() {
      this.isLoading = true;
      let tbType = this.$route.params.tbType;

      this._request = {};
      this._api = `/reports/transactions?tbType=${tbType}`;

      try {
        let res = await postRequest(this._api, this._request);

        this.transaction = res.data.total_transactions;
        this.total_sale = res.data.total_sales;
        this.details = res.data.records.transactions;
        this.pageInfo = res.data.records.pagination;
      } catch (e) {
        console.log(e);
      }
      this.isLoading = false;
    },

    async loadStatus() {
      try {
        let res = await getRequest(`/statuses/transaction`);
        this.statuses = res.data;
      } catch (e) {
        console.log(e);
      }
    },

    async loadProduct() {
      try {
        let res = await getRequest(`/products/staff`);
        this.products = res.data;
      } catch (e) {
        console.log(e);
      }
    },

    destroyDatatable() {
      $("#transaction_table").DataTable().destroy();
    },

    async submit_query() {
      this.isLoading = true;
      this.searchID = "";

      let tbType = this.$route.params.tbType;

      this._api = `/reports/transactions?tb_type=${tbType}`;

      this._request = {
        status: this.statusFilter,
        product: this.productFilter,
        date_to_p: this.date_to,
        date_from_p: this.date_from,
        tbType: tbType,
      };

      try {
        let res = await postRequest(this._api, this._request);

        this.transaction = res.data.total_transactions;
        this.total_sale = res.data.total_sales;
        this.details = res.data.records.transactions;
        this.pageInfo = res.data.records.pagination;
      } catch (e) {
        console.log(e);
      }
      this.isLoading = false;
    },

    async handlePageChange(page) {
      this.isLoading = true;

      let api_url = this._api + `&page=${page}`;

      try {
        let res = await postRequest(api_url, this._request);

        this.transaction = res.data.total_transactions;
        this.total_sale = res.data.total_sales;
        this.details = res.data.records.transactions;
        this.pageInfo = res.data.records.pagination;
      } catch (e) {
        console.log(e);
      }

      this.isLoading = false;
    },

    async onSearch() {
      this.isLoading = true;
      this.date_from = "";
      this.date_to = "";

      let tbType = this.$route.params.tbType;

      this._api = `/reports/transactions?tbType=${tbType}`;

      this._request = {
        tbType: tbType,
        search_for: this.searchID,
      };

      if (this.searchID == "" || this.searchID == null) {
        this._request = {};
      }

      try {
        let res = await postRequest(this._api, this._request);

        this.transaction = res.data.total_transactions;
        this.total_sale = res.data.total_sales;
        this.details = res.data.records.transactions;
        this.pageInfo = res.data.records.pagination;
      } catch (e) {
        console.log(e);
      }

      this.isLoading = false;
    },

    async onReset() {
      this.resetForm();
      this.loadAllData();
    },

    resetForm() {
      let tbType = this.$route.params.tbType;

      this.searchID = "";
      this.date_from = "";
      this.date_to = "";
      this._request = {};
      this._api = `/reports/transactions?tbType=${tbType}`;
    },

    customerPage(id) {
      return "/customer/" + id;
    },

    orderPage(id) {
      return "/tba/details/" + id;
    },

    loadAllData() {
      this.loadDetails();
      this.loadStatus();
      this.loadProduct();
      setTimeout(function () {}, 2000);
    },

    formatMoney(money) {
      return parseFloat(money).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },

  mounted() {
    this.loadAllData();
  },
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>
